import React from 'react';
import {useTranslation} from "react-i18next";
import { ISelectItem } from 'types/ui/Select/select-item.interface';

import * as S from './CustomDatePickerHeader.styled';

interface ICustomDatePickerHeaderProps {
  years: ISelectItem[];
  months: ISelectItem[];
  currentYear: string;
  currentMonth: string;
  handleYearChange: (newValue: string) => void;
  handleMonthChange: (newValue: string) => void;
}

export const CustomDatePickerHeader: React.FC<ICustomDatePickerHeaderProps> = ({
  years,
  months,
  currentYear,
  currentMonth,
  handleYearChange,
  handleMonthChange,
}) => {
  const { t } = useTranslation();

  const mappedMonths = months.map(month => {
    return {
      text: t(`months.${month.text}`),
      value: month.value,
      ...(month.icon && { icon: month.icon })
    }
  })

  return (
    <S.HeaderContainer>
      <S.MonthSelect items={mappedMonths} currentValue={currentMonth} onChange={handleMonthChange} />
      <S.YearSelect items={years} currentValue={currentYear} onChange={handleYearChange} />
    </S.HeaderContainer>
  );
};
